export default function(value) {
    return value.toLocaleString("da-dk", {minimumFractionDigits:2, maximumFractionDigits:2})
    // return value.toFixed(2).replace(".",",");
  }